import type { ListBuilderList } from '../../../types';
import { createStandardOrderColumns } from '../columns';
import { ORDER_REQUIRED_FIELDS, SALES_REP_FILTER_RULES } from '../shared';

/**
 * Default Orders All list configuration
 * Complete list of all orders with key details
 */
export const defaultOrdersAllList: ListBuilderList = {
	id: 'default-orders-all',
	cacheTTL: 600000,
	name: 'Last 90D',
	type: 'default',
	active: true,
	sortOrder: 6,
	columns: createStandardOrderColumns(),
	description: 'Complete list of all orders with key details',
	defaultSortId: 'column-dates-desc',
	requiredFields: ORDER_REQUIRED_FIELDS,
	filterRules: {
		...SALES_REP_FILTER_RULES,
		orderDateRange: {
			defaultValue: [
				{
					id: 'last-90-days',
					label: 'Last 90 Days',
					data: {
						startDate: '{{DATE:-90d}}',
						endDate: '{{DATE:0d}}',
					},
				},
			],
		},
	},
};
